import React, { lazy } from 'react';

import Loadable from 'react-loadable';

import { fg } from '@atlaskit/platform-feature-flags';
import Suspense from '@atlaskit/react-ufo/suspense';

import { importFeedbackFlag } from './import-feedback-flag';

type FeedbackFlagProps = React.ComponentProps<
	Awaited<ReturnType<typeof importFeedbackFlag>>['FeedbackFlagComponent']
>;

const LazyFeedbackFlagComponent = lazy(() =>
	importFeedbackFlag().then((module) => ({
		default: module.FeedbackFlagComponent,
	})),
);

const LoadableFeedbackFlagComponent = Loadable({
	loader: () => importFeedbackFlag().then(({ FeedbackFlagComponent }) => FeedbackFlagComponent),
	loading: () => null,
});
export const AsyncFeedbackFlagComponent = (props: FeedbackFlagProps): React.ReactElement => {
	if (fg('aimate_conversation_assistant_async_loading')) {
		return React.createElement(Suspense, {
			fallback: null,
			interactionName: 'rovo-conversation-assistant-feedback-flag',
			children: React.createElement(LazyFeedbackFlagComponent, props),
		});
	}
	return React.createElement(LoadableFeedbackFlagComponent, props);
};
